import { getReactHOTComposeFunction } from '../presets';
export const thunderboltBundlesConfig = {
    parts: false,
    components: true,
    host: true,
};
export const thunderboltConventions = {
    getComponentName: ({ componentName, placeholders }) => {
        if (placeholders.SkinName) {
            return `${componentName}_${placeholders.SkinName}`;
        }
        return componentName;
    },
    part: 'component',
    path: '{,*/}%ComponentName%/viewer/{%ComponentName%.tsx,skinComps/*/%SkinName%.skin.tsx}',
    compose: [getReactHOTComposeFunction()],
    patterns: [
        {
            part: 'controller',
            path: '{,*/}%ComponentName%/viewer/%ComponentName%.controller.ts',
        },
    ],
};
//# sourceMappingURL=thunderbolt.js.map